// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bTvfn","buttons":"styles_buttons__389fj"};